const html = require('choo/html');
const Component = require('choo/component');
const Account = require('./account');
const assets = require('../../common/assets');
const { platform } = require('../utils');

class Header extends Component {
  constructor(name, state, emit) {
    super(name);
    this.state = state;
    this.emit = emit;
    this.account = state.cache(Account, 'account');
  }

  update() {
    this.account.render();
    return false;
  }
  createElement() {
    const title =
      platform() === 'android'
        ? html`
            <a class="flex flex-col" href="https://gis.vn" target="_blank" rel="noopener noreferrer">
              <span class="font-extrabold tracking-tight leading-none" style="color: #ff0000; font-size: 28px;">gis.vn</span>
              <span class="text-sm font-medium mt-2 leading-tight" style="color: #000000;">Dịch vụ chia sẻ dữ liệu trực tuyến bảo mật mã hóa đầu cuối</span>
            </a>
          `
        : html`
            <a class="flex flex-col group transition-transform duration-200 hover:opacity-95" href="https://gis.vn" target="_blank" rel="noopener noreferrer">
              <span class="font-extrabold tracking-tight leading-none" style="color: #ff0000; font-size: 28px;">gis.vn</span>
              <span class="text-sm font-semibold tracking-normal mt-2 leading-tight" style="color: #000000;">Dịch vụ chia sẻ dữ liệu trực tuyến bảo mật mã hóa đầu cuối</span>
            </a>
          `;

    const navActions = html`
      <div class="flex items-center space-x-3 md:space-x-4">
        <a
          href="https://gis.vn"
          target="_blank"
          rel="noopener noreferrer"
          class="gis-home-link text-xs md:text-sm"
        >
          Trang chủ gis.vn
        </a>
        ${this.account.render()}
      </div>
    `;

    return html`
      <header
        class="main-header relative flex-none flex flex-row items-center justify-between w-full px-6 md:px-12 pt-2 md:pt-3 pb-1 md:pb-1.5 z-20 bg-transparent"
      >
        ${title} ${navActions}
      </header>
    `;
  }
}

module.exports = Header;
